<mat-toolbar color="primary" class="app-header">
  <pp-navigate-back />
  <!-- Logo and title are the shared widgets, which leave a small screen on their own; see testbedApplicationContext. -->
  @if (!isDesignRoute()) {
    <pp-app-logo link="/home" />
  }
  @if (!layoutService.isSmallDevice()) {
    <button mat-icon-button (click)="sidenavToggle()" class="example-icon" aria-label="Example icon-button with menu icon">
      <mat-icon>menu</mat-icon>
    </button>
  } @else {
    <ng-container *transloco="let t; prefix: 'navigation'">
      <div>
        <button test-id="menu-button" mat-button [matMenuTriggerFor]="beforeMenu">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu test-id="menu" #beforeMenu="matMenu" xPosition="before">
          @for (item of routes; track item) {
            <button mat-menu-item [routerLink]="item.path" [ngClass]="layoutService.layoutClass()">
              <span matListItemIcon class="material-symbols-outlined">{{ item.data?.['icon'] }}</span>
              <span matListItemTitle>&nbsp;{{ t(item.data?.['menuTitle'] | substring: 0) | substring: 24 }}</span>
            </button>
          }
        </mat-menu>
      </div>
    </ng-container>
  }
  <pp-app-title />
  <pp-task-dashboard-button />
  <pp-design-button />
  <pp-like-button />
  <pp-share-button />
  <pp-language-selector />
  <pp-auth-button />
</mat-toolbar>
